$('.content a[href]')
	// Фильтруем навигационные ссылки
	.filter(function () {
		return $(this).parents('nav').length === 0;
	})
	.each(function () {
		var $this = $(this);
		var href = $this.attr('href');
		// Если это не хеш, открываем в новом окне
		// if (href[0] !== '#') {
		// 	$this.attr('target', '_blank');
		// }
		// Если это полный адрес, добавляем модификатор --external
		// if (href.substring(0, 4) === 'http') {
		// 	$this.addClass('link--external');
		// }
		// Если это телефон, добавляем модификатор --phone
		if (href.substring(0, 4) === 'tel:') {
			$this.addClass('link--phone');
		}
	});



// WEBPACK FOOTER //
// ./temp/components/core/links.js